import { FaTwitter, FaInstagram, FaFacebook } from "react-icons/fa";
import { Link } from "react-router-dom";
import styles from './Footer.module.css';
import logo from './imgs/logo.png';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      {/* Brand Section */}
      <div className={styles.footerBrand}>
        <img src={logo} alt="Rustic Yarns Logo" className={styles.footerLogo} />
        <span className={styles.footerBrandText}>Rustic Yarns<br />Cozy. Creative. Handmade.</span>
      </div>
      {/* Links Section */}
      <div className={styles.footerLinks}>
        <div className={styles.footerLinksTitle}>Quick Links</div>
        <ul className={styles.footerLinksList}>
          <li><Link className={styles.footerLink} to="/">Home</Link></li>
          <li><Link className={styles.footerLink} to="/about">About</Link></li>
          <li><Link className={styles.footerLink} to="/products">Products</Link></li>
          <li><Link className={styles.footerLink} to="/courses">Courses</Link></li>
          <li><Link className={styles.footerLink} to="/contact">Contact</Link></li>
        </ul>
      </div>
      {/* Social Section */}
      <div className={styles.footerSocial}>
        <a href="https://twitter.com/home" className={styles.footerSocialIcon} target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
        <a href="https://www.instagram.com/rustic_yarn?igsh=MTRwaWdiNjNlN243eA==" className={styles.footerSocialIcon} target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
        <a href="https://youtube.com/@rusticyarn?si=HlQy-BXCTxj-lbKq" className={styles.footerSocialIcon} target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
      </div>
      <div className={styles.footerCopyright}>
        © {new Date().getFullYear()} Rustic Yarns. All rights reserved.
      </div>
    </footer>
  );
}
